/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInChatPrompts} from '../api'

 export const useQueryGetInChatPrompts = createReactQueryHook('getInChatPrompts', getInChatPrompts)
